<form [formGroup]="vericheckForm" (ngSubmit)="onSubmit()">
  <div class="form-row" style="row-gap: 7px; margin-top: 11px;">

    <div class="col-md-3">
      <div class="form__div mb-0 col-12 px-0">
        <ng-select class="ng-expiry-time" [items]="secCodeOptions" bindValue="value" bindLabel="displayName" 
                   [clearable]="false" [searchable]="false" placeholder="Select sec code" formControlName="secCode">
        </ng-select>
      </div>
      <div class="error-message" *ngIf="(vericheckForm.get('secCode')?.dirty || vericheckForm.get('secCode')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="vericheckForm.get('secCode')?.invalid">
          <span *ngIf="vericheckForm.get('secCode')?.errors.required" class="error-message">{{'vericheck.secCode' | translate}} is required</span>
        </ngb-alert>
      </div>
    </div>

    <div class="col-md-3 " style="height: 54px;">
      <div class="form__div col-12 px-0">
        <ng-select class="ng-expiry-time" [items]="accountTypeList" bindValue="name" bindLabel="name" [clearable]="false"
          [searchable]="false" [multiple]="false" placeholder="Select account type" notFoundText="No accountType selected" [readonly]="isMaskedCard" formControlName="accountType"
          [ngClass]="{'invalid-form-control': vericheckForm.get('accountType')?.errors?.required && submitted}">
        </ng-select>
      </div>
    </div>
    
    <div class="col-md-3">
      <div class="form__div mb-0 col-12">
        <input type="text" class="form__input" placeholder=" " formControlName="name" autocomplete="off" trim="blur" maxlength="25"
          [ngClass]="{'invalid-form-control': (vericheckForm.get('name')?.errors?.required || vericheckForm.get('name')?.errors?.pattern || vericheckForm.get('name')?.errors?.minAlphanumeric || vericheckForm.get('name')?.errors?.maxlength) && submitted}">
        <label *ngIf="vericheckForm.get('secCode')?.value === 'PPD' || vericheckForm.get('secCode')?.value === 'TEL'" class="form__label"><h6>{{'vericheck.name' | translate}}*</h6></label>
        <label *ngIf="vericheckForm.get('secCode')?.value === 'CCD'" class="form__label"><h6>Company Name*</h6></label>
      </div>
      <div class="error-message" *ngIf="(vericheckForm.get('name')?.dirty || vericheckForm.get('name')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="vericheckForm.get('name')?.invalid">
          <span *ngIf="vericheckForm.get('name')?.errors?.required" class="error-message">{{'vericheck.name' | translate}} is required</span>
          <span *ngIf="vericheckForm.get('name')?.hasError('pattern')" class="error-message">Only alphanumeric characters, spaces, . and ' allowed</span>
          <span *ngIf="!vericheckForm.get('name')?.hasError('pattern') && vericheckForm.get('name')?.hasError('minAlphanumeric')" class="error-message">Minimum 2 alphanumeric characters required.</span>
          <span *ngIf="!vericheckForm.get('name')?.hasError('pattern') && vericheckForm.get('name')?.hasError('maxlength')" class="error-message">Only 2–25 characters are allowed</span>
        </ngb-alert>
      </div>
    </div>

    <div class="col-md-3">
      <div class="form__div mb-0 col-12">
        <input *ngIf="!isMaskedCard" type="text" class="form__input" placeholder=" " formControlName="routingNumber"
               [mask]="maskedRoutingFormat" maxlength="9" autocomplete="off"
               [ngClass]="{'invalid-form-control': (vericheckForm.get('routingNumber')?.errors?.required || vericheckForm.get('routingNumber')?.errors?.pattern || vericheckForm.get('routingNumber')?.errors?.minlength) && submitted}">
        <input *ngIf="isMaskedCard" type="text" class="form__input" placeholder=" " formControlName="routingNumber" autocomplete="off"
               [ngClass]="{'invalid-form-control': (vericheckForm.get('routingNumber')?.errors?.required || vericheckForm.get('routingNumber')?.errors?.pattern || vericheckForm.get('routingNumber')?.errors?.minlength) && submitted}">
        <label class="form__label"><h6>{{'vericheck.routingNumber' | translate}}*</h6></label>
        <div class="input-group-prepend justify-content-end row" style="padding-top: 12px;" *ngIf="isMaskedCard && !isAddAchVericheck">
          <p type="button" (click)="!cardsLoading && getConsumersTokenDetail()"
            class="col-md-3 font-weight-bold cancel-btn text-right px-0"
            [class.cards-disabled]="cardsLoading"
            *ngIf="achCardsCountForButtons > 1">Cards
          </p>
          <p type="button" class="mdi mdi-close-circle-outline cancel-btn col-md-1 text-right font-weight-bold px-0"
            (click)="clearVericheckMaskedAlternateCardInfo()"
            *ngIf="!hideMaskedAchClear && !isfromRunASale"></p>
        </div>
      </div>
      <div class="error-message" *ngIf="(vericheckForm.get('routingNumber')?.dirty || vericheckForm.get('routingNumber')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="vericheckForm.get('routingNumber')?.invalid">
          <span *ngIf="vericheckForm.get('routingNumber')?.errors.required" class="error-message">{{'vericheck.routingNumber' | translate}} is required</span>
          <span *ngIf="vericheckForm.get('routingNumber')?.hasError('pattern')" class="error-message">Only numbers are allowed</span>
          <span *ngIf="vericheckForm.get('routingNumber')?.hasError('minlength')" class="error-message">Enter a minimum of 9 digits.</span>
        </ngb-alert>
      </div>
    </div>

    <div class="col-md-3">
      <div class="form__div mb-0 col-12">
        <input *ngIf="!isMaskedCard" type="text" class="form__input" placeholder=" " formControlName="accountNumber"
               [mask]="maskedAccountFormat" maxlength="17" autocomplete="off"
               [ngClass]="{'invalid-form-control': (vericheckForm.get('accountNumber')?.errors?.required || vericheckForm.get('accountNumber')?.errors?.pattern || vericheckForm.get('accountNumber')?.errors?.minlength || vericheckForm.get('accountNumber')?.errors?.maxlength) && submitted}">
        <input *ngIf="isMaskedCard" type="text" class="form__input" placeholder=" " formControlName="accountNumber" [attr.maxlength]="17" autocomplete="off"
               [ngClass]="{'invalid-form-control': (vericheckForm.get('accountNumber')?.errors?.required || vericheckForm.get('accountNumber')?.errors?.pattern || vericheckForm.get('accountNumber')?.errors?.minlength || vericheckForm.get('accountNumber')?.errors?.maxlength) && submitted}">
        <label class="form__label"><h6>{{'vericheck.accountNumber' | translate}}*</h6></label>
      </div>
      <div class="error-message" *ngIf="(vericheckForm.get('accountNumber')?.dirty || vericheckForm.get('accountNumber')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="vericheckForm.get('accountNumber')?.invalid">
          <span *ngIf="vericheckForm.get('accountNumber')?.errors.required" class="error-message">{{'vericheck.accountNumber' | translate}} is required</span>
          <span *ngIf="vericheckForm.get('accountNumber')?.hasError('pattern')" class="error-message">{{'vericheck.accountNumber' | translate}} accepts only numbers</span>
          <span *ngIf="vericheckForm.get('accountNumber')?.hasError('minlength') || vericheckForm.get('accountNumber')?.hasError('maxlength')" class="error-message">{{'vericheck.accountNumber' | translate}} should be 4 to 17 digits</span>
        </ngb-alert>
      </div>
    </div>

    <div class="col-md-9">
      <div class="form__div col-md-12 col-sm-12 mb-0">
        <input name="description" class="form__input" placeholder=" " maxlength="30"
          [ngClass]="{'invalid-form-control': (vericheckForm.get(['description']).errors?.required || vericheckForm.get(['description']).errors?.maxlength || vericheckForm.get(['description']).errors?.pattern ) && submitted}"
          formControlName="description" autocomplete="off">
        <label class="form__label" for="description">
          <h6>{{'htmlText.description' | translate}} *</h6>
        </label>
        </div>
        <div class="error-message" *ngIf="(vericheckForm.get('description')?.dirty || vericheckForm.get('description')?.touched || submitted)">
          <ngb-alert [dismissible]="false" [type]="'danger'" class="pt-md-1"
          *ngIf="vericheckForm.get('description')?.errors?.required">
            {{'errorMsg.requiredDescription' | translate}}
          </ngb-alert>
          <ngb-alert [dismissible]="false" [type]="'danger'" class="pt-md-1"
            *ngIf="vericheckForm.get('description')?.invalid && (vericheckForm.get('description')?.errors?.pattern ||vericheckForm.get('description')?.errors?.maxlength)"> 
            <i class="link-icon feather icon-alert-triangle"></i>
            {{'errorMsg.onlyAlphaNum' | translate}}
          </ngb-alert>
        </div>
    </div>

  </div>
</form>
